import React, { Component } from 'react'
import Pagination from 'components/grid/Pagination'

class DataGrid extends Component {
  state = {
  }

  constructor(props) {
    super(props)
    let pagination = {
      currentPage: 1,
      perPage: 10,
      total: props.items && props.items.length
    }

    this.state = {
      pagination,
      items: props.items && props.items.slice( 0, pagination.perPage)
    }
  }

  componentDidMount(){

  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      items: nextProps.items && nextProps.items.slice( 0, this.state.pagination.perPage)
    })
  }

  setPage(page) {
    this.props.setPage(page)
  }

  render() {
    const {
      columns,
      onRowClick,
      pagination,
      linkPrefix
    } = this.props

    const {items} = this.state

    return (
      <div className="jobRecruitment">
        <table cellPadding="0" cellSpacing="0">
          <thead>
            <tr>
            {columns && columns.map((column, i) => {
              return (
                <td key={i} width={column.width}>{column.label}</td>
              )
            })}
            </tr>
          </thead>
          <tbody>
            {items && items.map((item, i) => {
              return (
                <tr key={i} style={{cursor: 'pointer'}} onClick={onRowClick && onRowClick.bind(this, item)} >
                  {columns && columns.map((column, i) => {
                    return <td key={i}>{ column.render ? column.render(item[column['field']]) : item[column['field']]}</td>
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
        {items && <Pagination
          page={pagination.currentPage}
          perPage={pagination.perPage}
          total={pagination.total}
          setPage={this.props.setPage.bind(this)}
          linkPrefix={linkPrefix}
        />}
      </div>
    )
  }
}

export default DataGrid



// WEBPACK FOOTER //
// ./components/grid/DataGrid.js